import { useApp } from '@/store/AppContext'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { formatCurrency } from '@/lib/pricing'

export function SubscriberHistoryDialog({
  subscriberId,
  onClose,
}: {
  subscriberId: string | null
  onClose: () => void
}) {
  const { subscribers, subscriberPayments } = useApp()
  const sub = subscribers.find((s) => s.id === subscriberId)
  const payments = subscriberPayments
    .filter((p) => p.subscriberId === subscriberId)
    .sort((a, b) => b.paidAt.getTime() - a.paidAt.getTime())

  return (
    <Dialog open={!!subscriberId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Histórico: {sub?.name}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto mt-4 rounded-md border">
          <Table>
            <TableHeader className="bg-muted/50">
              <TableRow>
                <TableHead>Data Pgto</TableHead>
                <TableHead>Referência</TableHead>
                <TableHead>Método</TableHead>
                <TableHead className="text-right">Valor</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {payments.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    className="text-center h-24 text-muted-foreground"
                  >
                    Nenhum pagamento registrado.
                  </TableCell>
                </TableRow>
              ) : (
                payments.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell>
                      {p.paidAt.toLocaleDateString('pt-BR')}
                    </TableCell>
                    <TableCell className="font-medium">
                      {p.referenceMonth}
                    </TableCell>
                    <TableCell>
                      <span className="text-xs px-2 py-1 bg-secondary/10 text-secondary rounded-full font-medium">
                        {p.method}
                      </span>
                    </TableCell>
                    <TableCell className="text-right font-bold">
                      {formatCurrency(p.amount)}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  )
}
